import {Component, Input, OnInit} from '@angular/core';
import * as moment from 'moment';
import {Event} from '../../api/model/event';
import {GenderPrice} from '../../api/model/gender-price';
import {AudienceType} from '../../api/model/audience-type';
import {SettingsService} from '../../api/resources/settings/settings.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StaticUtils} from '../../utils/static-utils';

@Component({
  selector: 'app-product-event-day-card',
  templateUrl: './product-event-day-card.component.html',
  styleUrls: ['./product-event-day-card.component.scss']
})
export class ProductEventDayCardComponent implements OnInit {
  @Input('date') date = '';
  @Input('events') events: Event[] = [];
  utils = StaticUtils;
  eventsGenderPrices: GenderPrice[] = [];
  moment = moment;

  constructor(
    private _settingsService: SettingsService,
    private _route: ActivatedRoute,
    private _router: Router) { }

  ngOnInit() {
    this.eventsGenderPrices = this.getEventsGenderPrices(this.events);
  }

  getGenderPriceByAudienceTypeId(genderPrices: GenderPrice[], audienceTypeId: number): GenderPrice {
    let result = new GenderPrice();
    result.grossprice = 0;
    for (const genderPrice of genderPrices) {
      if (genderPrice.audienceType === audienceTypeId) {
        result = genderPrice;
        break;
      }
    }

    return result;
  }

  getSplitPriceValue(genderPrice: GenderPrice): number {
    let result = 0;
    // if (genderPrice.genderPriceType === 2) {
      for (const genderPriceComponent of genderPrice.productGenderPriceComponents) {
        result += genderPriceComponent.selectedPrice.value;
      }
    // }
    return result;
  }

  getEventsGenderPrices(events: any[]): GenderPrice[] {
    const eventsGenderPrices = [];
    if (events && events.length > 0) {
      for (const event of events) {
        for (const eventGenderPrice of event.eventGenderPrices || event.genders) {
          let contains = false;

          for (const genderPrice of eventsGenderPrices) {
            if (eventGenderPrice.audienceType === genderPrice.audienceType) {
              contains = true;
              break;
            }
          }

          if (!contains) {
            eventsGenderPrices.push(eventGenderPrice);
          }
        }
      }
    }
    return eventsGenderPrices;
  }

  goToBook(eventId: number, from: any, to: any) {
    this._router.navigate(
      ['../../book/' + eventId],
      { relativeTo: this._route });
  }

  getEventResourcesDescription(event: Event) {
    const result = [];

    for (const resource of event.eventResources) {
      result.push(resource.name);
    }

    return result.join(', ');
  }

  getEventAvailabilityDescription(event: Event): string {
    let result;
    switch (event.quantityAvailable) {
      case 0:
        result = 'Occupied';
        break;
      case -1:
        result = 'Unlimited';
        break;
      default:
        result = event.quantityAvailable + ' Available';
    }
    return result;
  }

  isEventBookingDisabled(event: Event): boolean {
    if(event.product.isSellableTillEnd) return moment(event.end).isBefore(moment()) || event.quantityAvailable === 0 || (event.isPrivateEvent && event.quantityBooked > 0);
    return moment(event.start).isBefore(moment()) || event.quantityAvailable === 0 || (event.isPrivateEvent && event.quantityBooked > 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/product-event-day-card/product-event-day-card.component.ts